import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/fcl/jiangsu/Index.vue')
const GuessRecords = () => import('../activity/fcl/jiangsu/GuessRecords.vue')
const FootballRecords = () => import('../activity/fcl/jiangsu/FootballRecords.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/fcl/jiangsu',
  name: 'activity_fcl_jiangsu',
  component: Index,
  props: (_route) => ({ ..._route.params, ..._route.query }),
  meta: {
    title: '苏超联赛',
  },
}

export const guessRecordsRoute: RouteConfig = {
  path: '/activity/fcl/jiangsu/guess-records',
  name: 'activity_fcl_jiangsu_guess_records',
  component: GuessRecords,
  props: (_route) => ({ ..._route.params, ..._route.query }),
  meta: {
    title: '竞猜历史记录',
  },
}

export const footballRecordsRoute: RouteConfig = {
  path: '/activity/fcl/jiangsu/football-records',
  name: 'activity_fcl_jiangsu_football_records',
  component: FootballRecords,
  props: (_route) => ({ ..._route.params, ..._route.query }),
  meta: {
    title: '足球获得明细',
  },
}

export default [indexRoute, guessRecordsRoute, footballRecordsRoute]
